import gql from 'graphql-tag';

export default gql`
	query FirstShipment {
		firstShipment {
			first_shipment
		}
	}
`;